<script setup>
defineProps({
  name: {
    type: String,
    required: true,
    // menu | search | chevron | pin | chat | external | uv | moon | sunrise | sunset
    validator: (v) => ['menu','search','chevron','pin','chat','external','uv','moon','sunrise','sunset','myLocation','close','home','clock','calendar','map','rain','thermometer','droplet','wind','humidity','eye','gauge','arrowLeft','running','shirt','snowflake','umbrella','air','warning','fish','activity','shield','doc','info','dropletFill'].includes(v)
  },
  size: { type: [Number, String], default: 20 }
})
</script>

<template>
  <svg :width="size" :height="size" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path v-if="name === 'menu'" d="M3 6h18M3 12h18M3 18h18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />

    <g v-else-if="name === 'search'">
      <circle cx="10.5" cy="10.5" r="6.5" stroke="currentColor" stroke-width="1.8" />
      <path d="M15.5 15.5L21 21" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
    </g>

    <path v-else-if="name === 'chevron'" d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />

    <path v-else-if="name === 'pin'" d="M12 21s7-6.2 7-11a7 7 0 1 0-14 0c0 4.8 7 11 7 11z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
    <circle v-if="name === 'pin'" cx="12" cy="10" r="2.6" stroke="currentColor" stroke-width="1.6" />

    <path v-else-if="name === 'chat'" d="M21 12a8.5 8.5 0 0 1-12.4 7.6L3 21l1.4-5.6A8.5 8.5 0 1 1 21 12z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />

    <g v-else-if="name === 'external'">
      <path d="M14 4h6v6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M20 4l-8.5 8.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" />
      <path d="M18 14.5V19a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 4 19V8a1.5 1.5 0 0 1 1.5-1.5H10" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" />
    </g>

    <g v-else-if="name === 'uv'">
      <circle cx="12" cy="14" r="3.4" stroke="currentColor" stroke-width="1.6" />
      <path d="M12 2v3M4.5 6l2.2 2.2M19.5 6l-2.2 2.2M2 14h3M19 14h3M4.5 22l2.2-2.2M19.5 22l-2.2-2.2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
      <path d="M12 20.5v2M9.6 20.8l-.5 1.8M14.4 20.8l.5 1.8" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
    </g>

    <path v-else-if="name === 'moon'" d="M20 14.5A8.5 8.5 0 1 1 9.5 4a8.5 8.5 0 0 0 10.5 10.5z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />

    <g v-else-if="name === 'sunrise'">
      <path d="M2 20h20" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" />
      <path d="M7 20a5 5 0 0 1 10 0" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" />
      <path d="M12 4v4M5.6 7.4l2.4 2.4M18.4 7.4L16 9.8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
    </g>

    <g v-else-if="name === 'sunset'">
      <path d="M2 20h20" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" />
      <path d="M7 20a5 5 0 0 1 10 0" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" />
      <path d="M12 4v3M5.6 7.4l2.4 2.4M18.4 7.4L16 9.8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity=".6" />
    </g>

    <g v-else-if="name === 'myLocation'">
      <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.7" />
      <path d="M12 2v3M12 19v3M2 12h3M19 12h3" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" />
      <circle cx="12" cy="12" r="7.5" stroke="currentColor" stroke-width="1.4" stroke-dasharray="3 3" />
    </g>

    <path v-else-if="name === 'close'" d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />

    <path v-else-if="name === 'home'" d="M4 11l8-7 8 7M6 10v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-9" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round" />

    <g v-else-if="name === 'clock'">
      <circle cx="12" cy="12" r="8.5" stroke="currentColor" stroke-width="1.7" />
      <path d="M12 7.5V12l3 2" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" />
    </g>

    <g v-else-if="name === 'calendar'">
      <rect x="4" y="5" width="16" height="15" rx="2" stroke="currentColor" stroke-width="1.7" />
      <path d="M4 9h16M8 3v4M16 3v4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" />
    </g>

    <g v-else-if="name === 'map'">
      <path d="M9 4L4 6v14l5-2 6 2 5-2V4l-5 2-6-2z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
      <path d="M9 4v14M15 6v14" stroke="currentColor" stroke-width="1.6" />
    </g>

    <g v-else-if="name === 'rain'">
      <path d="M7 13a4 4 0 0 1 .5-7.96A5 5 0 0 1 17 7a3.5 3.5 0 0 1 .3 7H7z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
      <path d="M9 17l-1 3M13 17l-1 3M17 17l-1 3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
    </g>

    <g v-else-if="name === 'thermometer'">
      <path d="M10 4a2 2 0 0 1 4 0v9.3a4.5 4.5 0 1 1-4 0V4z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
      <circle cx="12" cy="17" r="1.8" fill="currentColor" />
    </g>

    <g v-else-if="name === 'droplet'">
      <path d="M12 3.5s6 6.3 6 10.2a6 6 0 1 1-12 0C6 9.8 12 3.5 12 3.5z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
    </g>

    <!-- 实心水滴：小尺寸下识别度更高（降水概率前缀用） -->
    <path
      v-else-if="name === 'dropletFill'"
      d="M12 2.8c.9 0 5.6 5.5 5.6 9.7a5.6 5.6 0 1 1-11.2 0C6.4 8.3 11.1 2.8 12 2.8z"
      fill="currentColor"
    />

    <g v-else-if="name === 'wind'">
      <path d="M3 8h9.5a2.5 2.5 0 1 0-2.4-3.2M3 12h13.5a2.5 2.5 0 1 1-2.4 3.2M3 16h7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
    </g>

    <g v-else-if="name === 'humidity'">
      <path d="M12 3.5s6 6.3 6 10.2a6 6 0 1 1-12 0C6 9.8 12 3.5 12 3.5z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
      <path d="M9 14.5a3 3 0 0 0 3 3" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
    </g>

    <g v-else-if="name === 'eye'">
      <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
      <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.6" />
    </g>

    <g v-else-if="name === 'gauge'">
      <path d="M4 15a8 8 0 1 1 16 0" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
      <path d="M12 15l4-4.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" />
      <circle cx="12" cy="15" r="1.6" fill="currentColor" />
      <path d="M4 19h16" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
    </g>

    <g v-else-if="name === 'air'">
      <path d="M20 4c0 9-5.6 14-12 14H5C5 9.4 10.6 4 20 4z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
      <path d="M4.5 20.5c2.2-4.2 6-7.4 10.5-9.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
    </g>

    <path v-else-if="name === 'arrowLeft'" d="M15 5l-7 7 7 7" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" />

    <g v-else-if="name === 'running'">
      <circle cx="13.5" cy="4.5" r="1.8" fill="currentColor" />
      <path d="M10 20.5l2.2-5-2.7-2.6 1.2-5.3 3.8-.4 2.6 4.1 3 .9" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M11.8 10.8L8.5 12l-2.8 4M14.8 18.4l1.6 2.6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
    </g>

    <g v-else-if="name === 'shirt'">
      <path d="M8 4l4 2 4-2 4.5 3-2 3.5-1.5-.8V20h-10V9.7L5.5 10.5 3.5 7 8 4z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
    </g>

    <g v-else-if="name === 'snowflake'">
      <path d="M12 2v20M4 6l16 12M20 6L4 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
      <path d="M9 4l3 2 3-2M9 20l3-2 3 2" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
    </g>

    <g v-else-if="name === 'umbrella'">
      <path d="M12 3a9 9 0 0 1 9 9H3a9 9 0 0 1 9-9z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
      <path d="M12 12v6.5a2.2 2.2 0 0 0 4.4 0" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
      <path d="M12 2v1" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
    </g>

    <g v-else-if="name === 'warning'">
      <path d="M12 3.5l9 16A1.5 1.5 0 0 1 19.8 21.5H4.2A1.5 1.5 0 0 1 3 19.5z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
      <path d="M12 9.5v4.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      <circle cx="12" cy="17" r="1.1" fill="currentColor" stroke="none" />
    </g>

    <g v-else-if="name === 'fish'">
      <path d="M3 12c3-4 7-5 11-3 2 .9 4 1 6-1v6c-2-2-4-1.9-6-1-4 2-8 1-11-3z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
      <circle cx="7" cy="10.5" r="1" fill="currentColor" stroke="none" />
    </g>

    <!-- 生活指数（心跳折线） -->
    <path v-else-if="name === 'activity'" d="M3 12.5h4l2.5-6 4 12 2.5-6h5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />

    <!-- 隐私协议（盾牌 + 勾） -->
    <g v-else-if="name === 'shield'">
      <path d="M12 3l7.5 3v6c0 4.6-3.1 8-7.5 9.5C7.6 20 4.5 16.6 4.5 12V6z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
      <path d="M8.8 12.2l2.4 2.4 4.2-4.6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" />
    </g>

    <!-- 使用条款（文档 + 文本行） -->
    <g v-else-if="name === 'doc'">
      <path d="M6 3h8l4 4v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
      <path d="M14 3v4h4M8.5 12h7M8.5 16h7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </g>

    <!-- 关于我们（信息圆） -->
    <g v-else-if="name === 'info'">
      <circle cx="12" cy="12" r="8.5" stroke="currentColor" stroke-width="1.7" />
      <path d="M12 11v5.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      <circle cx="12" cy="7.9" r="1.1" fill="currentColor" stroke="none" />
    </g>
  </svg>
</template>
